module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-01"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "hidden-xs-only",
    attrs: {
      "xs12": "",
      "sm1": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 100,
      "imaSrc": "design/gray-arrow",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "¿Cuáles son sus metas a…",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("¿Cuáles"), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partTwo"
  }, [_vm._v("son sus ")]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(" metas a…")])], 2)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": '¿Cuáles son sus metas?',
      "videoEmbed": "ADMINISTRACIONDINERO06MetasEnElTiempo.mp4"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "mt-5": ""
    }
  }, [_c('v-flex', {
    staticClass: "animated fadeInLeft dura_2",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md4": ""
    }
  }, [_c('ui-list', {
    attrs: {
      "bullet": "bullet-dav",
      "lista": _vm.lista
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInDown dura_3 aligner",
    attrs: {
      "xs12": "",
      "sm4": "",
      "md4": ""
    }
  }, [_c('p', [_vm._v("\n        Si aún no tiene claras sus "), _c('strong', [_vm._v("metas, este es el mejor momento")]), _vm._v(" para empezar a hacerlo."), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Dedíquele unos cuantos minutos")]), _vm._v(" y verá cómo sus "), _c('strong', [_vm._v("decisiones")]), _vm._v(" se vuelven más "), _c('strong', [_vm._v("efectivas")]), _vm._v(".\n      ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-540525a1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-06.vue
// module id = 976
// module chunks = 1